import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from '#/renderer/router';
import { useHookstate } from '@hookstate/core';
import { usePathname } from 'next/navigation';

// helpers
import { currencyFormat, imgFormat, chargeFormat } from '~/helpers/formatter';
import prodHelper from '~/helpers/product';
import useStores from '~/store/StoreHook';
import { cuotaState } from '~/store/States/checkout';
import { usePospagoState } from '~/store/States/pospago';
//import blukai, removido
import { hookstate } from '@hookstate/core';

export const esimConfig = hookstate({});

const CartSummaryImg = ({ itemInfo }) => (
  <picture>
    <img src={(itemInfo && itemInfo.images && itemInfo.images.length ? imgFormat('90x90', `${process.env.NEXT_PUBLIC_CDN_PATH}${itemInfo.images[0]}`) : '')} alt="alt" />
  </picture>
);

const CartSummaryDesc = ({ itemInfo, addonsList, quantity, hasEsim = false }) => {
  const esimConfigLocal = useHookstate(esimConfig);
  let specs;
  let isAddOn = false;
  if (Object.keys(itemInfo).length) {
    specs = (itemInfo.attributes).reduce((a, b, i) => {
      const index = `cartSummary-spec-${i}`;
      if (b.identifier === 'def-capacidad' || b.identifier === 'def-color' || b.identifier === 'def-pantalla') {
        a.push(<p key={index}><span>{b.value}</span></p>);
      }
      if (b.identifier === 'attr-conf-tipoproducto' && b.value === 'ADDONS') {
        isAddOn = true;
      }
      if (isAddOn && b.identifier === 'attr-short-description') {
        a.push(<p key={index}><span>{b.value}</span></p>);
      }

      return a;
    }, []);
  }


  const esimConfigToUse = esimConfigLocal.get();
  const conEsimTexto = esimConfigToUse && esimConfigToUse.cart && esimConfigToUse.cart.conEsim ? esimConfigToUse.cart.conEsim : ''

  if (hasEsim) {
    specs.push(<p key={9}><span>{conEsimTexto}</span></p>)
  }

  const fullname = Object.keys(itemInfo).length ? itemInfo.locales[process.env.NEXT_PUBLIC_LOCALE].name.replace(/<br>/, '\n').replace(/<br\/>/, '\n').replace(/\\n/, '\n').split('\n')
    .map((str, index) => <p key={`title--${itemInfo.part_number}-${index}`}>{str}</p>) : '';
  return (
    <div className="cart--summary-desc">
      <b>{addonsList.some(x => x.item_part_number === itemInfo.part_number) ? 'Adicional' : 'Producto'}</b>
      <div>{fullname} {quantity > 1 && `(${quantity})`}</div>
      {specs}
    </div>
  );
};

const CartSummarySub = ({ itemInfo, quantity, cartItem, cart, included, isCartNoTodoIncluido, textoPospago }) => {
  const attrMap = cartItem._attrMap;
  const tipo = attrMap['attr-conf-tipoproducto'];
  const tipoPlan = attrMap['attr-conf-tipoplan']?.toUpperCase() || '';
  const precioMensual = attrMap['attr-conf-precio-mensual'];
  const noIncluido = cartItem._noTodoIncluido;
  let currencyText;
  let isIncluded = false;
  let priceLabel = 'Precio';
  if (cartItem.part_number_kit) {
    const sp = cartItem.part_number_kit.split('--');
    const plan = sp[1];
    const plazo = sp[2];
    currencyText = currencyFormat(itemInfo.pricing.pospago[plan][plazo].offer_price, 1).split('.');
    isIncluded = included;
    if (isCartNoTodoIncluido) {
      priceLabel = textoPospago?.carrito.terminal;
    }
  } else if (tipo === 'PLAN' && tipoPlan === 'FIJO' && noIncluido) {
    const kitItem = cart.find(it => it.part_number_kit);
    if (kitItem) {
      const sp = kitItem.part_number_kit.split('--');
      const plan = sp[1];
      const plazo = sp[2];
      currencyText = currencyFormat(((kitItem.product.items[0].pricing.pospago[plan][plazo].financing || 0) / plazo) + +precioMensual, 1).split('.');
      priceLabel = textoPospago?.carrito.plan;
    }
  } else {
    currencyText = currencyFormat(itemInfo.pricing[process.env.NEXT_PUBLIC_CURRENCY].offer_price * quantity).split('.');
    if (currencyText[0] === '0' && currencyText[1] === '00' && precioMensual) {
      currencyText = currencyFormat(precioMensual, 1).split('.');
    }
  }

  return (
    <div className="cart--summary-sub">
      <b>{priceLabel}</b>
      <p style={{ whiteSpace: 'nowrap' }}>
        {isIncluded ? (
          <span>INCLUIDO</span>
        ) : (
          <>
            <span className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
            <span>{currencyText[0]}.</span>
            <span className="symbol">{currencyText[1]}</span>
          </>
        )}
      </p>
    </div>
  );
};

const CartSummaryDetail = ({
  itemInfo,
  addonsList,
  quantity,
  cartItem,
  cart,
  hasEsim,
  included,
  isCartNoTodoIncluido,
  textoPospago,
}) => {
  const pospagoState = usePospagoState(!!cartItem.part_number_kit);
  if (pospagoState.config.product_sku_sin_equipo.value === cartItem.part_number) {
    return null;
  }

  const sinEquipoItem = cart.find((x) => x.part_number === 'K01_0001_001');

  return (
    <div className="cart--summary-detail">
      <CartSummaryImg itemInfo={itemInfo} />
      <section>
        <CartSummaryDesc
          itemInfo={itemInfo}
          addonsList={addonsList}
          quantity={quantity}
          hasEsim={hasEsim || sinEquipoItem?.esim}
        />
        <CartSummarySub
          itemInfo={itemInfo}
          addonsList={addonsList}
          quantity={quantity}
          cartItem={cartItem}
          cart={cart}
          included={included}
          isCartNoTodoIncluido={isCartNoTodoIncluido}
          textoPospago={textoPospago}
        />
      </section>
    </div>
  );
};

const CartSummaryAddress = withRouter(({ cartInfo, location }) => {
  const isPayment = location.pathname === '/checkout/payment';
  let output;
  if (isPayment) {
    return null;
  } else { output = ''; }
  return output;
});

const UI = ({ cartInfo, addonsList }) => {
  const pathname = usePathname();
  const [chargeTitle, setChargeTitle] = useState();
  const { orderStore } = useStores();
  const [precio_minimo_incluido, setPrecio_minimo_incluido] = useState(0);
  const [textoPospago, setTextoPospago] = useState();
  let showing = false;
  const cuotas = useHookstate(cuotaState.cuotas);

  useEffect(() => {
    async function init() {
      if (!orderStore.getCartConfig || !orderStore.getCartConfig.success) {
        await orderStore.getConfig();
      }
      await orderStore.getConfigEsim();
      if (orderStore.getCartConfig.success) {
        setChargeTitle(orderStore.getCartConfig.data.data.chargeTitle);
        setTextoPospago(orderStore.getCartConfig.data.data.textoPospago);
        if (orderStore.getCartConfig.data.data.precio_minimo_incluido) {
          setPrecio_minimo_incluido(+(orderStore.getCartConfig.data.data.precio_minimo_incluido));
        }
      }
      if (orderStore.getEsimConfig.success) {
        const esimConfigToSet = orderStore.getEsimConfig.data.data;
        esimConfig.set(esimConfigToSet)
      }
    }
    init();
  }, []);

  let grandTotal;
  if (cartInfo && cartInfo.amount && cartInfo.amount[process.env.NEXT_PUBLIC_CURRENCY]) {
    grandTotal = cartInfo.amount[process.env.NEXT_PUBLIC_CURRENCY].grand_total;
    const isPayment = pathname === '/checkout/payment';
    if (isPayment && cuotas.value > 0) {
      grandTotal /= cuotas.value;
    }
    grandTotal = currencyFormat(grandTotal).split('.');
    const centsTemp = parseInt(grandTotal[1], 10);
    grandTotal[1] = centsTemp < 100 ? centsTemp : centsTemp - 100;
  }

  let total;
  let total_text;
  if (precio_minimo_incluido){
    const amount = grandTotal ? grandTotal[0] : '';
    const decimals = grandTotal ? String(grandTotal[1]).padStart(2, '0') : '';
    total_text = `${amount}.${decimals}`;
    total = +total_text;
    showing = total <= precio_minimo_incluido;
  }

  const itemInfo = {};
  const cartItems = cartInfo.items || [];
  cartItems.forEach((data) => {
    data._attrMap = prodHelper.convertAttributes(data.product.items[0].attributes);
    data._noTodoIncluido = data.product.type === '2' && data._attrMap['attr-conf-todo-incluido']?.toUpperCase() === 'NO';
  });
  const isCartNoTodoIncluido = cartItems.some(it => it._noTodoIncluido);
  const included = showing && isCartNoTodoIncluido;

  const cartDetails = cartItems.map((data, i) => {
    const index = `item--${data.part_number}--${i}`;
    (data.product.items).map((items) => {
      itemInfo[items.part_number] = items;
      return items;
    });
    return (
      <CartSummaryDetail
        hasEsim={data?.esim}
        key={index}
        itemInfo={itemInfo[data.part_number]}
        addonsList={addonsList}
        quantity={+data.quantity}
        cartItem={data}
        cart={cartInfo.items}
        included={included}
        isCartNoTodoIncluido={isCartNoTodoIncluido}
        textoPospago={textoPospago}
      />
    );
  });

  return (
    <section className="cart--summary">
      <header className="cart--summary-header">
        <p>Resumen de compra</p>
        <Link onClick={()=> {
          //blukai function, removida
          }} to="/cart" id="editar-carrito">Editar</Link>
      </header>
      {cartDetails}
      {/* {isRegister ? addOnsDetails : null} */}
      <aside className="cart--summary-total">
        <b className={isCartNoTodoIncluido ? 'pospago-total' : ''}>{cuotas.value && !included ? `Tu compra en ${cuotas.value} cuotas` : isCartNoTodoIncluido ? textoPospago?.carrito.total_resumen : 'Total' }:</b>
        <p>
          {included ? (
            <span>INCLUIDO</span>
          ) : (
            <>
              <span className="symbol">{process.env.NEXT_PUBLIC_CURRENCY_SYMBOL}</span>
              <span>{grandTotal ? grandTotal[0] : ''}.</span>
              <span className="symbol">{grandTotal ? String(grandTotal[1]).padStart(2, '0') : ''}</span>
              {cuotas.value ? (
                <span>/mes</span>
              ) : null }
            </>
          )}
        </p>
      </aside>
      { showing ? chargeFormat(chargeTitle, total_text) : ''}
      <CartSummaryAddress cartInfo={cartInfo} />
    </section>
  );
};

UI.propTypes = {
  cartInfo: PropTypes.shape({}),
};

UI.defaultProps = {
  cartInfo: {},
};

CartSummaryDetail.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummaryDetail.defaultProps = {
  itemInfo: {},
};

CartSummaryDesc.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummaryDesc.defaultProps = {
  itemInfo: {},
};

CartSummarySub.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummarySub.defaultProps = {
  itemInfo: {},
};

CartSummaryImg.propTypes = {
  itemInfo: PropTypes.shape({}),
};

CartSummaryImg.defaultProps = {
  itemInfo: {},
};

CartSummaryAddress.propTypes = {
  cartInfo: PropTypes.shape({}),
};

CartSummaryAddress.defaultProps = {
  cartInfo: {},
};

export default UI;
